<template>
    <vs-prompt class="d-flex" buttons-hidden :title="'Copiar liquidación'" :active.sync="showDialogLiquidationCopy">
        <div style="padding: 20px;">
            <vs-row>
                <p>Selecciona la empresa para la cual deseas copiar la liquidación seleccionada</p>
            </vs-row>
            <vs-row>
                <CompanySelector v-model="companyCopy"></CompanySelector>
            </vs-row>
            <br />
            <vs-row class="d-flex justify-content-end">
                <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
                    <div class="d-flex">
                        <vs-button color="primary" class="flex-shrink-0 ml-auto" style="margin-top: 0px;"
                            @click="liquidationCopy()">Copiar</vs-button>
                    </div>
                </vs-col>
            </vs-row>
        </div>
    </vs-prompt>
</template>
<style>
.vs-dialog {
    max-width: 800px !important;
}
</style>
  
<script>
import CompanySelector from "@/components/Shared/CompanySelector";
import { ROUTES } from "@/global/api_routes";

export default {
    name: "DialogLiquidationCopy",
    components: {
        CompanySelector
    },
    props: {
        openDialogLiquidationCopy: { type: Boolean },
        company: { type: String },
        liquidation: { type: Object },
    },
    data: () => ({
        showDialogLiquidationCopy: false,
        companyCopy: null
    }),
    watch: {
        openDialogLiquidationCopy() {
            this.showDialogLiquidationCopy = this.openDialogLiquidationCopy;
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        liquidationCopy() {
            this.$vs.loading();
            this.$http
                .post(ROUTES.DASHBOARD.LIQUIDATIONS.COPY_LIQUIDATION, this.getObj())
                .then(({ data }) => {
                    if (data.code > 0) {
                        this.$toastOk("Se ha guardado correctamente el registro");
                        return;
                    }
                    else { this.$toastError(data.message); }
                })
                .finally(() => {
                    this.$vs.loading.close();
                });
            this.close();
        },
        getObj() {
            return {
                code: this.liquidation.code,
                title: this.liquidation.title,
                numeral: this.liquidation ? this.liquidation.numeral : 1,
                company: { code: this.companyCopy },
                liquidationType: { code: this.liquidation.liquidationType.code },
                relatedList: this.liquidation.relatedList
            }
        }
    }
};
</script>